// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"417":"7f582ec14bfdc2a1","1439":"2ddeb18dc027d9e5","3497":"3d5b888c85b45301","3594":"9bc7e9441bdab1de"}[chunkId] + ".js";
};